var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.985 36.615a5.21 5.21 0 00-2.752-2.785l-.016-.007a3.457 3.457 0 001.413-2.797c0-1.907-1.526-3.452-3.41-3.452-1.884 0-3.411 1.545-3.411 3.452 0 1.15.557 2.17 1.414 2.799l-.017.006a5.23 5.23 0 00-2.752 2.785 5.224 5.224 0 00-.405 1.922.11.11 0 00.11.114h.825a.11.11 0 00.11-.108A4.173 4.173 0 0129.3 35.7a4.075 4.075 0 012.919-1.223c1.103 0 2.138.434 2.918 1.223a4.174 4.174 0 011.208 2.844.11.11 0 00.11.108h.825a.11.11 0 00.079-.033.112.112 0 00.03-.08 5.24 5.24 0 00-.405-1.924zm-4.765-3.196c-.631 0-1.226-.249-1.673-.7a2.393 2.393 0 01-.693-1.693c0-.639.246-1.24.693-1.692a2.336 2.336 0 011.673-.702c.631 0 1.225.25 1.672.701.447.453.693 1.054.693 1.693s-.246 1.24-.693 1.692a2.336 2.336 0 01-1.672.701z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.627 23.546c-5.175.198-9.31 4.505-9.31 9.79 0 5.411 4.335 9.797 9.683 9.797 5.273 0 9.562-4.266 9.68-9.574H43c-.117 6.046-4.997 10.91-11 10.91-6.077 0-11.003-4.984-11.003-11.133 0-6.022 4.725-10.927 10.627-11.127.304-1.528 1.637-2.678 3.236-2.678 1.823 0 3.301 1.495 3.301 3.34 0 1.844-1.478 3.34-3.3 3.34-1.595 0-2.925-1.144-3.234-2.665zm3.233 1.329c1.094 0 1.98-.898 1.98-2.004a1.992 1.992 0 00-1.98-2.005c-1.093 0-1.98.898-1.98 2.005 0 1.106.887 2.004 1.98 2.004z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/Audience.a2f62dcfdb83c6e066ee1db55b8f650c.svg";
export { ForwardRef as ReactComponent };